export default class SubLandUseViewModel {
    mainLandUse: string = '';
    subLandUseCode: string = '';
    description: string = '';
    part1Description: string = '';
    part1Abbreviation: string = '';
    park1Unit: string = '';
    part1Calculation: number | null = null;
    part2Description: string = '';
    part2Abbreviation: string = '';
    park2Unit: string = '';
    part2Calculation: number | null = null;
}